import { useState, useEffect } from 'react';

// Define a mapping for your media queries
const mediaQueryMap = {
    Mobile: '(max-width: 430px)',
    Tablet: '(min-width: 431px) and (max-width: 1149px)',
    NotDesktop: '(max-width: 1149px)',
    Desktop: '(min-width: 1150px)',
};

type MediaQueryType = keyof typeof mediaQueryMap;

const useMediaQuery = (query: MediaQueryType): boolean => {
    const mediaQuery = mediaQueryMap[query];
    const [matches, setMatches] = useState<boolean>(() => window.matchMedia(mediaQuery).matches);

    useEffect(() => {
        const mediaQueryList = window.matchMedia(mediaQuery);
        const listener = (event: MediaQueryListEvent) => {
            setMatches(event.matches);
        };

        mediaQueryList.addEventListener('change', listener);
        return () => {
            mediaQueryList.removeEventListener('change', listener);
        };
    }, [mediaQuery]);

    return matches;
};

export default useMediaQuery;
